





















































































































































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { post } from '@/fn/ajax'
import { Input, Button, Tooltip, message } from 'ant-design-vue'
import { login } from '@/api/auth'
import { getCurrentLocale } from '@/i18n'
import { detect } from 'detect-browser'

@Component({
  components: {
    Input,
    Button,
    Tooltip
  }
})
export default class Growlib extends ViewBase {
  uname = ''

  unameError = ''

  pwd = ''

  pwdError = ''

  img: any = {
    logo: require('./assets/logo.png'),
    v1: {
      img0: require('./assets/v1.0.png'),
      img1: require('./assets/v1.1.png'),
      img2: require('./assets/v1.2.png'),
      img3: require('./assets/v1.3.png'),
      img4: require('./assets/v1.4.png'),
      img5: require('./assets/v1.5.png'),
      img6: require('./assets/v1.6.png'),
      img7: require('./assets/v1.7.png')
    },
    v2: {
      img0: require('./assets/v2.0.png'),
      img1: require('./assets/v2.1.png'),
      img2: require('./assets/v2.2.png'),
      img3: require('./assets/v2.3.png'),
      img4: require('./assets/v2.4.png')
    },
    v3: {
      img0: require('./assets/v3.0.png'),
      img1: require('./assets/v3.1.png'),
      img2: require('./assets/v3.2.png'),
      img3: require('./assets/v3.3.png'),
      img4: require('./assets/v3.4.png')
    }
  }
  submitting = false

  passwordType = 'password'

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get i18n1() {
    const value = this.$t('app')
    return value as any
  }
  mounted() {
      const { name } = detect() || { name: 'chrome' }
      const tip = name == 'ie'
      ? this.i18n1.notSupportBrowserTip
      : !['chrome', 'safari', 'opera'].includes(name)
      ? this.i18n1.betterBrowserTip
      : ''
      if (tip) {
      setTimeout( () => {
        const el: any = document.getElementById('topbar-browser-tip')  //  createElement('div')
      el.innerHTML = `${tip}`
      } , 200 )
    }
  }
  gotop() {
    // this.$refs.inputuname.focus()
    const el: any = this.$refs.inputuname
    el.focus()
    // let docEl = document.documentElement as HTMLDivElement
    // document.getElementById("inputuname").focus();
  }
  async submit() {
    // message.error('This is a message of error');

    this.unameError = ''
    this.pwdError = ''
    if (!this.uname) {
      message.error(this.i18n.needUserName)
      return
    } else if (!this.pwd) {
      message.error(this.i18n.needPassword)
      return
    }
    this.submitting = true
    try {
      const data = await login({ uname: this.uname, pwd: this.pwd })

      const oldschool = localStorage.school
      // 本次登录和上次不一样
      if (JSON.stringify(data.school) != localStorage.school) {
        localStorage.changeschool = 'true'
      } else {
        localStorage.changeschool = 'false'
      }
      localStorage.school = JSON.stringify(data.school)
      this.$store.commit('saveLogin', data)
      this.$store.commit('setPlayList', [])
      this.$router.push({ name: 'home' })
      this.$i18n.locale = getCurrentLocale()
      // 修改浏览器提示信息
      const { name } = detect() || { name: 'chrome' }
      const tip = name == 'ie'
      ? this.i18n1.notSupportBrowserTip
      : !['chrome', 'safari', 'opera'].includes(name)
      ? this.i18n1.betterBrowserTip
      : ''
      if (tip) {
      setTimeout( () => {
        const el: any = document.getElementById('topbar-browser-tip')  //  createElement('div')
        el.innerHTML = `${tip}`
      } , 200 )
      }
       document.title = this.i18n1.htmltitle
    } catch (ex) {
      const name = `submitError${ex.s}`
      name in this ? (this as any)[name](ex) : this.handleError(ex)
    } finally {
      this.submitting = false
    }
  }

  submitError900() {
    message.error(this.i18n.userHint)
    this.unameError = this.i18n.userHint
  }

  submitError901() {
    message.error(this.i18n.passwordHint)
    this.pwdError = this.i18n.passwordHint
  }

  showPwd() {
    if (this.passwordType === 'password') {
      this.passwordType = ''
    } else {
      this.passwordType = 'password'
    }
    // this.$nextTick(() => {
    //   this.$refs.password.focus()
    //   document.getElementById('password').focus()
    // })
  }
}
